import Swiper from 'swiper';
import { Pagination, Autoplay, Navigation } from 'swiper/modules';

$(document).ready( function () {
    const swiper = new Swiper('#scegli-corsi-slider', {
        autoplay: false,
        init : true,
        dragFreeMode: false,
        spaceBetween: 5,
        loop: true,
        loopPreventsSliding: false,
        centeredSlides: false,
        modules: [Pagination, Autoplay, Navigation],
        slidesPerView: 1,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
            enabled: false
        },
        breakpoints: {
            570: {
                slidesPerView: 2,
                navigation: {
                    enabled: true
                }
            },
            1024: {
                slidesPerView: 3,
                navigation: {
                    enabled: true
                }
            }
        },
        on: {
            init: function () {
                $('#scegli-corsi-slider').removeClass('hidden')
            }
        }
    })
})
